module.exports = __webpack_public_path__ + "static/media/23.f6db1db.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/23.wav
// module id = WY8p
// module chunks = 0